import { render, staticRenderFns } from "./postComments.vue?vue&type=template&id=3fa8429b&scoped=true"
import script from "./postComments.vue?vue&type=script&lang=js"
export * from "./postComments.vue?vue&type=script&lang=js"
import style0 from "./postComments.vue?vue&type=style&index=0&id=3fa8429b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa8429b",
  null
  
)

export default component.exports